























































import { Vue, Component } from "vue-property-decorator";
import BaseComponent from "@/asdcom/BaseComponent";
import util from "@/lib/util";
import moment from "moment";
import {
  NewVcClaimLogInputDto,
  EventType
} from "@/asdcom/apiproxy/apiproxy.dto";
import { ConstantValuesItem } from "@/store/models/common";

@Component({})
export default class NewLogEntry extends BaseComponent {
  loading: boolean = false;
  dueDate: string = "";
  viewModel = new NewVcClaimLogInputDto();
  claimNumber: string;
  logTypes: any[] = [];

  async created() {
    this.claimNumber = this.$route.params.claimNumber;
    let manualEventTypes: EventType[] = await this.$appsvs.vcpOnlineOkStaff.retrieveManualEventTypes();
    
    // manualEventTypes.forEach((i: number) => {
    //   this.logTypes.push(util.abp.constant.eventType.values[i-1])
    // })
    
    const filteredList = (util.abp.constant.eventType.values as ConstantValuesItem[]).filter(v => {
      return manualEventTypes.some(i => v.value == i);
    });
    /// sort final list.
    this.logTypes = this.getConstValuesSorted(filteredList);
  }

  get maxDate() {
    return moment()
      .add(90, "days")
      .format("YYYY-MM-DD");
  }

  get minDate() {
    return moment().format("YYYY-MM-DD");
  }

  onClose() {
    this.$emit("onClose");
    this.viewModel = new NewVcClaimLogInputDto();
  }

  onSave() {
    this.ValidateAll().then((isValid: boolean) => {
      if (isValid) {
        this.loading = true;
        this.viewModel.claimNumber = this.claimNumber;
        this.viewModel.dueDate = moment(this.dueDate);

        this.$appsvs.vcpOnlineOkStaff
          .createVcClaimLog(this.viewModel)
          .then((res: any) => {
            this.$appsvs.vcpOnlineOkStaff.refreshTaskCounts();
            this.onClose();
          }).finally(() => {
            this.loading = false;
          });
      }
    });
  }
}
